exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fukidashi-base[data-v-ba2f1d12]{width:100%;min-height:100px;position:relative}.fukidashi-base svg[data-v-ba2f1d12]{display:block;position:absolute;top:0;left:0;-webkit-box-sizing:border-box;box-sizing:border-box}.fukidashi-base.reverse svg[data-v-ba2f1d12]{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fukidashi-base p[data-v-ba2f1d12]{position:relative;z-index:10;text-align:left;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba2f1d12","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/recommend/line_special/partials/FukidashiBase.vue
// module id = dvUh
// module chunks = 0